import axios from "axios";
import { BASE_URL, TRACKER_BASE_URL } from "./Baseurl";

const Api = axios.create({
  baseURL: BASE_URL,
});
export const TrackerApi = axios.create({
  baseURL: TRACKER_BASE_URL,
});
export default Api;
